import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent, computed } from 'vue';
import type { Traveller } from '@white-label-types/travel-insurance';
import {
  getAgeGroupOrder,
  getCustomerGroupLabel,
  getProductTypeCustomerGroupLabels,
} from '@white-label-helper/get-product-type-customer-group-labels';
import type { ProductType } from '@white-label-configuration/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-traveller-details',
  props: {
    travellers: null,
    productType: null
  },
  setup(__props: any) {

const props = __props as {
  travellers: Traveller[],
  productType:ProductType,
};


const travellers = computed(() => props.travellers
  .map((traveller, index) => ({ traveller, index }))
  .sort((left, right) => {
    if (left.traveller.is_lead !== right.traveller.is_lead) {
      return left.traveller.is_lead ? -1 : 1;
    }

    const leftAgeGroupOrder = getAgeGroupOrder(left.traveller.user.age_group);
    const rightAgeGroupOrder = getAgeGroupOrder(right.traveller.user.age_group);

    if (leftAgeGroupOrder !== rightAgeGroupOrder) {
      return leftAgeGroupOrder - rightAgeGroupOrder;
    }

    return left.index - right.index;
  })
  .map(({ traveller }) => traveller));

const customerGroupLabels = computed(() => getProductTypeCustomerGroupLabels(props.productType));

function resolveCustomerGroupLabel(ageGroup: Traveller['user']['age_group']): string {
  return getCustomerGroupLabel(ageGroup, customerGroupLabels.value);
}

const IconUser = defineAsyncComponent(() => import('@white-label-icon/icon-user'));

return { __sfc: true,props, travellers, customerGroupLabels, resolveCustomerGroupLabel, IconUser }
}

})